import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=4c5345b4&"
import script from "./ResultView.vue?vue&type=script&lang=js&"
export * from "./ResultView.vue?vue&type=script&lang=js&"
import style0 from "./ResultView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports